import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Our response to the eMudhra certificate incident",
  header:
    "Security update: How Controla is responding to the eMudhra certificate incident",
  date: "2026-10-21",
  description:
    "Eight certificates issued by eMudhra have been disclosed as compromised. Here’s how we’ve updated the Controla app and our servers, and what it means for you.",
  category: "security",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
